import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";

import { isEmpty, orderBy } from "lodash";
import NavigationBarContainer from "../NavigationBarContainer";
import KlagerapportFilterContainer from "./KlagerapportFilterContainer";
import KlagerapportLedelseList from "./KlagerapportLedelse";

function KlagerapportPage() {
  const klagerapport = useSelector((state) => state.klagerapport);
  const klageRapportFilterFormState = useSelector(
    (state) => state.forms.klageRapportFilterForm,
  );
  const initSelectedIleggelsestyper =
    klageRapportFilterFormState &&
    klageRapportFilterFormState.selectedIleggelsestyper &&
    klageRapportFilterFormState.selectedIleggelsestyper.map((sit) => sit.navn);

  const [selectedIleggelsestyper, setSelectedIleggelsestyper] = useState(
    initSelectedIleggelsestyper,
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {}, []);

  const sorter = (arr) => {
    const selectedSort = klageRapportFilterFormState.selectedSort;
    const splitt = selectedSort.split("_");
    const key = splitt[0];
    const order = splitt[1];
    if (isEmpty(arr)) return [];
    return orderBy(arr, [key], [order]);
  };

  const bydelerArr = sorter(klagerapport.stedDimensionList);
  const overtredelseKodeArr = sorter(klagerapport.overtredelseDimensionList);

  return (
    <Container fluid>
      <Row>
        <Col>
          {<NavigationBarContainer page="klager" />}
          <div className="rapportSearch">
            <KlagerapportFilterContainer
              updateSelectedIleggelsestyperState={setSelectedIleggelsestyper}
            />
          </div>
          <div className="rapport-table">
            <KlagerapportLedelseList
              klagerapport={klagerapport}
              bydelerArr={bydelerArr}
              overtredelseKodeArr={overtredelseKodeArr}
              selectedIleggelsestyper={selectedIleggelsestyper}
            />
          </div>
        </Col>
        <div style={{ height: 28 }} />
      </Row>
    </Container>
  );
}

export default KlagerapportPage;
